import React, { useMemo } from 'react';
import ExclusionListSection from '../components/settings/exclusion-list-section';
import { useGetClientExclusionsQuery } from '../endpoints/client-exclusions.endpoints';

const SettingsTab: React.FC = () => {
  const { data: exclusions = [], isLoading } = useGetClientExclusionsQuery();

  const domainEntries = useMemo(
    () => exclusions.filter((entry) => entry.type === 'domain'),
    [exclusions],
  );
  const appEntries = useMemo(
    () => exclusions.filter((entry) => entry.type === 'app'),
    [exclusions],
  );

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="mx-auto flex max-w-3xl flex-col gap-6">
        <div>
          <h1 className="text-xl font-medium text-gray-900">Settings</h1>
          <p className="mt-1 text-sm text-gray-500">
            Global client report settings. Excluded domains and apps are hidden from client-facing
            report dashboards (new and legacy reporters).
          </p>
        </div>

        <ExclusionListSection
          title="Excluded Domains"
          type="domain"
          entries={domainEntries}
          isLoading={isLoading}
        />
        <ExclusionListSection
          title="Excluded Apps"
          type="app"
          entries={appEntries}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default SettingsTab;
